import {EventEmitter, Input, Output} from '@angular/core';
import {Table, TableKey, TYPE_DATA, ValueDropdown} from '../../models/table';
import {InBaseFrwComponent} from '../inBaseFrwComponent';

export class TableBase extends InBaseFrwComponent {

  @Input() table = new Table();
  @Output() tableChange = new EventEmitter();
  @Output() onReloadData = new EventEmitter();
  @Output() onActionItem = new EventEmitter();
  @Output() onActionRedirect = new EventEmitter();
  @Output() onChangeModel = new EventEmitter();
  @Input() key: TableKey;
  @Input() row: any;
  @Input() columnsTemplates: any;
  @Input() model: any;

  constructor() {
    super();
  }


  get totalPages() {
    let retorno = Number(this.table.results.total_resources / this.table.pagination.maxRows);
    retorno = Math.ceil(retorno);
    return retorno;
  }

  reloadData() {
    this.tableChange.emit(this.table);
    this.onReloadData.emit(null);
  }

  nextPreviousPage(next = true) {
    next ? this.table.pagination.page += 1 : this.table.pagination.page -= 1;
    this.reloadPage();
  }

  reloadPage() {
    if (!this.isValidPage) {
      setTimeout(() => this.table.pagination.page = 1, 500);
      return;
    }

    this.reloadData();
  }

  get isValidPage() {
    return Number(this.table.pagination.page) > 0 && Number(this.table.pagination.page) <= this.totalPages;
  }

  clickBoolCustom() {
    if (this.key.type_data === TYPE_DATA.BOOLEAN && this.key.value_DROPDOWN && this.key.value_DROPDOWN.length) {
      const aux0 = this.key.value_DROPDOWN.filter(e => e.value === this.model)[0];
      const index = this.key.value_DROPDOWN.indexOf(aux0);
      let item = null;
      if (index < (this.key.value_DROPDOWN.length - 1)) {
        item = this.key.value_DROPDOWN[index + 1].value;
      }
      this.model = item;
      this.filterBySearch();
    }
  }


  get customBoolean(): ValueDropdown {

    return this.key.value_DROPDOWN.filter(e => {
      let retorno = e.value === this.model;
      if (this.key.type_data === TYPE_DATA.BOOLEAN) {
        retorno = this.model === true ? e.value === true : e.value !== true;
      }
      return retorno;
    })[0];
  }

  changeMaxRows(a) {
    this.table.pagination.maxRows = a;
    this.table.pagination.page = 1;
    this.reloadData();
  }

  getClassTD(key, row) {
    let retorno = 'align-middle position-relative ' + key.class;
    return retorno;
  }

}
